<template>
  <div>
    <!-- 搜索接口目前没有，搜索功能不全暂时先隐藏-->
    <!-- <div style="text-align:center;padding:10px 10px;">
        <a-input placeholder="请输入内容" v-model="searchValue"    style="width:50%;height:40px;" allow-clear/>
        <a-button type="primary" style="height:40px;">搜索</a-button>
    </div> -->
    <iframe
      src="http://47.97.18.42:12821/public/dashboards/Xpv9paZ4N3FKG12tpZyT601ImhkLrsBQzKw1h2pN?org_slug=default"
      frameborder="0"
      style="width:100%;height:700px"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'wechatHome',
  data() {
    return {
      searchValue: ''
    };
  }
};
</script>

<style scoped>
@import '~@assets/less/common.less';
</style>
